import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatNativeDateModule } from "@angular/material/core";
import {
  MatDatepickerModule
} from "@angular/material/datepicker";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { APCustomer } from "../../_models/customer.interface";
import { CustomerService, ProjectService } from "../../_services";
import { RecordNavigationComponent } from "../_shared/record-navigation/record-navigation.component";
import { Router } from "@angular/router";

@Component({
  selector: 'hawk-project-create',
  imports: [
    RecordNavigationComponent,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FaIconComponent,
  ],
  templateUrl: './project-create.component.html',
  standalone: true,
  styleUrls: ['./project-create.component.scss'],
  host: {
    class: 'app-page'
  }
})
export class ProjectCreateComponent implements OnInit {

  projectForm: UntypedFormGroup;
  customers: APCustomer[] = []
  customerSearchText: string = ''
  filteredCustomers: APCustomer[] = []

  constructor(
    private projectService: ProjectService,
    private customerService: CustomerService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.initProjectForm()
    this.loadCustomers()
  }

  loadCustomers(): void {
    this.customerService.loadAPCustomers().subscribe(
      data => {
        this.customers = data
        this.filteredCustomers = [...this.customers]
      },
      err => console.log(err)
    )
  }

  initProjectForm(): void {
    this.projectForm = this.getProjectForm()
  }

  getProjectForm(): UntypedFormGroup {
    const form = new UntypedFormGroup({
      "name": new UntypedFormControl({value: ''}, Validators.required),
      "description": new UntypedFormControl({value: ''}),
      "type": new UntypedFormControl({value: ''}, Validators.required),
      "customer_id": new UntypedFormControl({value: null}, Validators.required),
      "cost_center": new UntypedFormControl({value: ''}),
      "cut_off_time": new UntypedFormControl({value: ''}),
      "select_products": new UntypedFormControl({value: false}),
      "contact": new UntypedFormControl({value: ''}),
      "email": new UntypedFormControl({value: ''}),
      "start": new UntypedFormControl({value: ''}),
      "end": new UntypedFormControl({value: ''}),
      "fallback_date": new UntypedFormControl({value: ''}),
      "send_operation_new": new UntypedFormControl({value: false}),
      "send_operation_update": new UntypedFormControl({value: false}),
      "send_operation_delete": new UntypedFormControl({value: false}),
      "additional_documentation": new UntypedFormControl({value: ''}),
      "is_dismantling_project": new UntypedFormControl({value: false}),
    })

    form.controls['name'].setValue('')
    form.controls['description'].setValue('')
    form.controls['type'].setValue('')
    form.controls['customer_id'].setValue(null)
    form.controls['cost_center'].setValue('')
    form.controls['cut_off_time'].setValue('')
    form.controls['select_products'].setValue(false)
    form.controls['contact'].setValue('')
    form.controls['email'].setValue('')
    form.controls['start'].setValue('')
    form.controls['end'].setValue('')
    form.controls['fallback_date'].setValue('')
    form.controls['send_operation_new'].setValue(false)
    form.controls['send_operation_update'].setValue(false)
    form.controls['send_operation_delete'].setValue(false)
    form.controls['additional_documentation'].setValue('')
    form.controls['is_dismantling_project'].setValue(false)

    form.updateValueAndValidity()

    return form
  }

  onSubmit() {
    this.projectService.createProject({
      name: this.projectForm.controls['name'].value,
      description: this.projectForm.controls['description'].value,
      type: this.projectForm.controls['type'].value,
      customer_id: this.projectForm.controls['customer_id'].value,
      cost_center: this.projectForm.controls['cost_center'].value,
      cut_off_time: this.projectForm.controls['cut_off_time'].value,
      select_products: this.projectForm.controls['select_products'].value,
      contact: this.projectForm.controls['contact'].value,
      email: this.projectForm.controls['email'].value,
      start: this.projectForm.controls['start'].value,
      end: this.projectForm.controls['end'].value,
      fallback_date: this.projectForm.controls['fallback_date'].value,
      send_operation_new: this.projectForm.controls['send_operation_new'].value,
      send_operation_update: this.projectForm.controls['send_operation_update'].value,
      send_operation_delete: this.projectForm.controls['send_operation_delete'].value,
      additional_documentation: this.projectForm.controls['additional_documentation'].value,
      is_dismantling_project: this.projectForm.controls['is_dismantling_project'].value,
      active: true
    }).subscribe(
      data => {
        this.router.navigate([`/projekt/${data.id}`])
      },
      error => {
        console.log(error)
      }
    )
  }

  protected readonly faInfoCircle = faInfoCircle;

  filterCustomers(target: EventTarget) {
    if (target) {
      this.customerSearchText = (target as HTMLInputElement).value
    } else {
      this.customerSearchText = ''
    }
    this.filteredCustomers = this.customers.filter(c => [c.name, c.company].find(s => s && s.includes(this.customerSearchText)))
  }
}
